import { render } from "./CookiesSignIn.vue?vue&type=template&id=4d7b811c&scoped=true&ts=true&lang=ts"
import script from "./CookiesSignIn.vue?vue&type=script&lang=ts"
export * from "./CookiesSignIn.vue?vue&type=script&lang=ts"

import "./CookiesSignIn.vue?vue&type=style&index=0&id=4d7b811c&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7b811c"]])

export default __exports__